import { Outlet } from 'react-router-dom';

/** מסכים ציבוריים: כניסה, קוד, התקנה, הרשמה ב QR. בלי תפריט. */
export function PublicLayout() {
  return <Outlet />;
}
